import React, {useState } from 'react'
import { Modal, Box, Typography, Button, Input, IconButton } from "@mui/material"
import closeicon from '@meprism/shared/src/assets/icons/successclose.png'

interface AuthLetterEmployeeModalProps {
    open: boolean
    onClose: () => void
    onSave: (signature: string, index: number) => void
    index: number,
    currentAuthSignature: string
  }
  
  const EmployeeAuthLetterModal = ({
    open,
    onClose,
    onSave,
    index,
    currentAuthSignature
  }: AuthLetterEmployeeModalProps) => {
    const [authSignature, setAuthSignature] = useState(currentAuthSignature)

    const fontssign={
      Allison: {
        Regular:{
          fontFamily: 'AllisonRegular',
        }  
    }}
    const textStyle = {
      ...fontssign.Allison.Regular,
      fontSize: '50px',
      color:'black'
    }

        const handleSave = () => {
        onSave(authSignature, index)
        onClose()
        }
    
        return (
            <Modal
            open={open}
            onClose={onClose}
            sx={{
              backdropFilter: 'blur(40px)',
            }}
          >
             <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'white',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          width:"auto",
          maxWidth: 700,
          maxHeight: '80vh',
          overflowY: 'auto',
        }}
      >
        <Box sx={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between', alignItems:'center', mb:5}}>
            <Typography variant="h2">
            AUTHORIZATION LETTER
            </Typography>

            <IconButton
                edge="end"
                color="inherit"
                onClick={handleSave}
               >
            <img src={closeicon} style={{width: '42px'}}/>
            </IconButton>
        </Box>

        <Typography variant="body2" sx={{ mb: 1 }}>
          I, {authSignature? authSignature :"Your Name"}, hereby authorize Priwall Inc.
          (“Priwall”) to act as my authorized agent under the California Consumer
          Privacy Act (CCPA) and all other current and future privacy and data
          security laws. This authorization grants Priwall the power to take any
          necessary and reasonable actions to protect my privacy rights, including
          but not limited to removing, suppressing, or opting-out my personal
          information from any unwanted sources.
        </Typography>

        <Typography variant="body2" sx={{ mb: 1 }}>
          Priwall is authorized to contact third parties, such as data brokers,
          people search companies, and data aggregators, to exercise my rights to
          delete and opt-out of the sale and disclosure of my personal information.
          I acknowledge that Priwall will not be held liable for any actions taken
          under this authorization, provided that they act reasonably.
        </Typography>

        <Typography variant="body2" sx={{ mb: 3 }}>
          This authorization will remain in full force and effect until I cancel my
          service with Priwall.
        </Typography>

        <Typography variant="body2" sx={{ mb: 1 }}>
          Signature:
        </Typography>
        <Box sx={{display:"flex", flexDirection:"row"}}>
          <Input
            type="text"
            value={authSignature}
            onChange={(e) => setAuthSignature(e.target.value)}
            placeholder="Enter employee name"
            style={{ width: '50%', padding: '8px', marginBottom: '16px' }}
          />
          <Typography sx={{width:'50%', ml: '30px', ...textStyle }}>
            {authSignature}
          </Typography>

        </Box>
        <Button onClick={handleSave}>Save and adopt as signature</Button>
      </Box>
          </Modal>
        )
  }
  
  export default EmployeeAuthLetterModal
  